import useMobileView from '../../../hooks/useMobileView';
import { generateLeftPaddingValue } from '../../../utils/asideNavi/generateLefPaddingValue';
import { AsideNavigationItemType } from '../organisms/AsideNavigationBlock';
import { AsideNavigationItemButton } from './AsideNavigationItemButton';
import { LinkComponent } from './LinkComponent';
import { useLocation } from '@tanstack/react-router';

export interface AsideNavigationItemProps {
	item: AsideNavigationItemType;
	itemLevel?: number;
	hasChildren?: boolean;
	naviBlockIsOpen?: boolean;
	setNaviBlockIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
	naviSectionIsOpen?: boolean;
	setNaviSectionIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AsideNavigationItem = ({
	item,
	itemLevel,
	naviBlockIsOpen,
	setNaviBlockIsOpen,
	naviSectionIsOpen,
	setNaviSectionIsOpen,
}: AsideNavigationItemProps) => {
	const isMobile = useMobileView(900);
	const location = useLocation();
	const currentLocation = location.pathname.replace(/\/$/, '');
	const isExpanded = currentLocation.includes(item.Url.replace(/\/$/, ''));
	const {
		DisplayName: text,
		Url: url,
		IsAnchor: isAnchor,
		Children: children,
	} = item;
	const hasChildren = children.length !== 0;
	const isMainNaviElement = !itemLevel;

	const currentUrl = location.href;

	const stripTrailingSlash = (str: string) => {
		return str.endsWith('/') ? str.slice(0, -1) : str;
	};

	const isCurrentItem =
		stripTrailingSlash(currentUrl) === stripTrailingSlash(url);

	const listItemClassNames = `px-2.5 ${isCurrentItem && isMobile ? 'bg-secondary-yellow p-0' : ''} `;
	const containerClassNames = `${isMobile ? 'h-14' : ''} flex items-center justify-between ${generateLeftPaddingValue(isMainNaviElement, itemLevel, isMobile)} ${isCurrentItem && !isMobile ? 'bg-secondary-yellow rounded-2xs' : ''}`;
	const itemClassNames = `flex flex-1 items-center justify-between px-2.5 ${isMobile ? 'underline' : 'py-2'} ${isExpanded && !isMainNaviElement ? 'font-bold' : ''} ${!isMobile ? 'hover:underline' : ''}`;

	const shouldShowButton = isMainNaviElement
		? isMobile
		: !isAnchor && hasChildren;

	return (
		<li className={listItemClassNames}>
			<div className={containerClassNames}>
				<LinkComponent url={url} className={itemClassNames}>
					{text}
				</LinkComponent>
				{shouldShowButton && (
					<AsideNavigationItemButton
						naviBlockIsOpen={naviBlockIsOpen}
						naviSectionIsOpen={naviSectionIsOpen}
						isMainNaviElement={isMainNaviElement}
						setNaviBlockIsOpen={setNaviBlockIsOpen}
						setNaviSectionIsOpen={setNaviSectionIsOpen}
					/>
				)}
			</div>
		</li>
	);
};
